<template>
    <connection-settings-popup
        :resources="{
            deletePromptTitle: resource('JourneyBuilder_FilterSettings_Delete_Title'),
            deletePromptBody: resource('JourneyBuilder_FilterSettings_Delete_Body'),
            deleteButtonText: resource('JourneyComposer_JourneyBrickMenu_DeleteConnection')
        }"

        @save="save()"
        @delete="deleteConnection()"
        @hidden="$emit('hidden')"
    >
        <template #title>
            <div>
                <h3>{{resource("JourneyComposer_ConnectionModal_Connection")}}</h3>

                <copy-id-button :id="connection.id" />
            </div>
        </template>

        <template #body>
            <template v-if="canBeConfigured">
                <h4>{{resource("JourneyBuilder_JourneyBrickMenu_Status_DisplayName")}}</h4>
                <div class="row mb-2">
                    <label for="active" class="col-2">{{resource("Bool_Active")}}</label>
                    <span class="col-10">
                    <input id="active" type="checkbox" v-model="active" :disabled="!canWrite" />
                </span>
                </div>
                <div class="row mb-2">
                    <label for="activeFrom" class="col-2">{{resource("JourneyComposer_ConnectionModal_ActiveFrom")}}</label>
                    <span class="col-10">
                    <input type="date" class="form-control" v-model="activeFrom" :disabled="!canWrite" />
                </span>
                </div>

                <template v-if="canWrite">
                    <hr />
                </template>
            </template>

            <template v-if="canWrite">
                <h4>{{resource("JourneyBuilder_JourneyBrick_CommentHeader")}}</h4>
                <new-comment :brickId="commentId" :id="'newcomment'" />
            </template>

            <template v-if="!connection.isNew">
                <hr />
                <h4>{{resource("JourneyBuilder_JourneyBrickMenu_Comments_DisplayName")}}</h4>
                <div class="comment-container">
                    <comments-section
                        :related-id="connection.id"
                        type="Connection"
                    />
                </div>
            </template>
        </template>
    </connection-settings-popup>
</template>

<script>
import resources from '@core/Util/Mixins/resources';
import permissions from '@modules/JourneyBuilder/Mixins/journey-permissions';
import CopyIdButton from "@modules/JourneyBuilder/Components/Elements/CopyIdButton";
import ConnectionSettingsPopup from '../ConnectionSettingsPopup';
import { CommentsSection, NewComment } from '@modules/JourneyBuilder/Components/Composer/CanvasArea/Bricks/Comments';

export default {
    components: {
        CommentsSection,
        CopyIdButton,
        NewComment,
        ConnectionSettingsPopup
    },
    
    mixins: [ resources, permissions ],

    props: {
        /** @type {JourneyBrickConnection} */
        connection: Object
    },

    data: () => ({
        active: false,
        activeFrom: null,
        comments: []
    }),

    computed: {
        commentId() {
            return "connection:" + this.connection.id + ":default";
        },
        
        canBeConfigured(){
            //https://datanext.atlassian.net/browse/DPN-3123
            //Connections leading to a parent journey brick may not be configured
            return !this.connection.destinationBrick.isParentJourneyBrick;
        }
    },

    mounted() {
        const vm = this;
        
        if (vm.connection.startDate) {
            const split = vm.connection.startDate.split('-');
            const d = split[0].length == 1 ? '0' + split[0] : split[0];
            const m = split[1].length == 1 ? '0' + split[1] : split[1];
            const y = split[2];
            vm.activeFrom = `${y}-${m}-${d}`;
        }
        vm.active = !vm.connection.isDisabled;
    },

    methods: {
        save() {
            let activeFrom = null;
            if (this.activeFrom) {
                const activeFromDate = new Date(this.activeFrom);
                const d = activeFromDate.getDate() < 10 ? "0" + activeFromDate.getDate() : activeFromDate.getDate();
                const m = activeFromDate.getMonth() < 9 ? "0" + (activeFromDate.getMonth() + 1) : (activeFromDate.getMonth() + 1);
                const y = activeFromDate.getFullYear(); 
                activeFrom = `${d}-${m}-${y}`;
            }

            this.$emit("change-status", { active: this.active, activeFrom });
        },

        deleteConnection() {
            this.$emit('delete-connection', this.connection.id);
        }
    },
}
</script>

<style scoped>
    .comments-section {
        width: 100%;
    }
</style>